import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import i18n from 'i18next';
import getBaseTheme from 'styles/getBaseTheme';
import config from 'utils/config';
import createElement from 'tricks/dom/createElement';
import loadScript from 'tricks/browser/http/loadScript';
import { typeScale } from 'styles/globals';
import { remToPx } from '../ui';
import { buildMindsetTheme, MINDSET_ID } from './mindsetAI';
import { getMindsetAuthToken } from './getMindsetAuthToken';
export function renderMindsetSDK2(_x) {
  return _renderMindsetSDK.apply(this, arguments);
}
function _renderMindsetSDK() {
  _renderMindsetSDK = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _parentEl$querySelect, _window$mindset;
    var scriptURL, appUid, initialQuestion, agentUid, existingMindsetScript, parentEl, theme, cardTheme, mindsetCustomEl, mindsetTheme, initData;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          scriptURL = _ref.scriptURL, appUid = _ref.appUid, initialQuestion = _ref.initialQuestion, agentUid = _ref.agentUid;
          existingMindsetScript = document.querySelector("script[src=\"".concat(scriptURL, "\"]"));
          if (existingMindsetScript) {
            delete window.mindset; // Clear any previous mindset instance
            delete window._mindset_; // Clear any previous mindset instance

            // Remove from the DOM
            // This is merely symbolic, as it does not change runtime of existing scripts
            existingMindsetScript.remove();
          }
          parentEl = document.getElementById(MINDSET_ID); // Remove any existing mindset agent element to avoid duplicates
          parentEl === null || parentEl === void 0 || (_parentEl$querySelect = parentEl.querySelector('mindset-agent')) === null || _parentEl$querySelect === void 0 || _parentEl$querySelect.remove();
          theme = getBaseTheme();
          cardTheme = theme.sections.card;
          mindsetCustomEl = createElement('mindset-agent', _objectSpread({
            agentUid: agentUid,
            style: "width: 100%; height: 70vh; display: block; background-color: ".concat(cardTheme.background, ";"),
            loadingText: i18n.t('loading')
          }, initialQuestion && {
            initialQuestion: initialQuestion
          }));
          parentEl === null || parentEl === void 0 || parentEl.appendChild(mindsetCustomEl);

          /** **************************
           * MINDSET SDK INITIALIZATION
           ** **************************/

          // Load the Mindset SDK script
          // HACK: We have to load this in every time our application changes the initialQuestion 🤯
          _context.next = 1;
          return loadScript(scriptURL);
        case 1:
          mindsetTheme = buildMindsetTheme(theme);
          initData = {
            fetchAuthentication: getMindsetAuthToken,
            appUid: appUid,
            theme: mindsetTheme,
            customFontTheme: {
              fontFamily: 'Open Sans',
              textStyles: {
                titleLarge: {
                  fontWeight: 600,
                  fontSize: remToPx(typeScale.l)
                },
                titleMedium: {
                  fontWeight: 600,
                  fontSize: remToPx(typeScale.m)
                },
                titleSmall: {
                  fontWeight: 600,
                  fontSize: remToPx(typeScale.m)
                },
                bodyLarge: {
                  fontWeight: 400,
                  fontSize: remToPx(typeScale.m)
                },
                bodyMedium: {
                  fontWeight: 400,
                  fontSize: remToPx(typeScale.s)
                },
                bodySmall: {
                  fontWeight: 400,
                  fontSize: remToPx(typeScale.s)
                }
              }
            }
          };
          if (config.mindsetAgentVoice) {
            initData.enableVoice = 'true';
          }

          // Reinitialize instead of re-injecting script e.g. when the initial question changes
          _context.next = 2;
          return (_window$mindset = window.mindset) === null || _window$mindset === void 0 ? void 0 : _window$mindset.init(initData);
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _renderMindsetSDK.apply(this, arguments);
}